export default __webpack_public_path__ + "static/media/instagram-share.61ae835f.svg";